import { ChangeEvent, useState } from "react";
import { Form } from "react-bootstrap";
import TextField from "@components/FormsV2/TextField/TextField";
import type { LobFormValues } from "../types";

export interface LineOfBusinessFormProps {
  id: string;
  initialValues: LobFormValues;
  isSubmitting: boolean;
  onSubmit: (values: LobFormValues) => void;
}

export const LineOfBusinessForm = ({
  id,
  initialValues,
  isSubmitting,
  onSubmit,
}: LineOfBusinessFormProps): JSX.Element => {
  const [values, setValues] = useState<LobFormValues>(initialValues);

  const set = <K extends keyof LobFormValues>(key: K, v: LobFormValues[K]) =>
    setValues((prev) => ({ ...prev, [key]: v }));

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    onSubmit(values);
  };

  return (
    <Form id={id} data-testid={id} onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-sm-4">
          <Form.Label htmlFor="lob-name">Name</Form.Label>
          <TextField
            label={null}
            id="lob-name"
            value={values.name}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              set("name", e.target.value)
            }
            required
          />
        </div>
        <div className="col-sm-4">
          <Form.Label htmlFor="lob-code">Code</Form.Label>
          <TextField
            label={null}
            id="lob-code"
            value={values.code}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              set("code", e.target.value)
            }
          />
        </div>
      </div>
    </Form>
  );
};

export default LineOfBusinessForm;
